'use strict';

const trackingUtils = require('../utils/tracking.utils');
const flowType = Odigeo.SessionScope.flow;
const oneClickCheckoutFactory =
    require(`components/one_click_checkout/js/main.${flowType === 'desktop' ? 'desktop' : 'mobile'}`);

const CATEGORY = 'my_area_trips_details';

module.exports = {
    translations: null,
    isOpen: false,
    isPriceBreakdownOpen: false,
    oneClickCheckoutContainer: null,

    selectors: {
        widget: '.post_booking_bags_widget',
        waiting: '.post_booking_bags_waiting',
        content: '.post_booking_bags_content',
        flightInfo: '.post_booking_flight_info',
        info: '.post_booking_bags_info',
        payment: '.post_booking_bags_payment',
        oneClickCheckout: '.one_click_checkout',
        purchase: '.post_booking_bags_purchase',
        body: '.post_booking_bags_body',
        headerTitle: '.post_booking_bags_header_title',
        headerBack: '.post_booking_bags_header_back',
        travelers: '.post_booking_bags_travelers',
        checkout: '.post_booking_bags_checkout',
        success: '.post_booking_bags_confirmation_success',
        paymentFailure: '.post_booking_bags_payment_failure',
        failure: '.post_booking_bags_failure',
        back: '.post_booking_ancillaries_back',
        selectableBaggage: '.post_booking_bags_selectable_baggage',
        selectBag: '.post_booking_bags_select_bag',
        removeBag: '.post_booking_bags_remove_bag',
        checkoutButton: '.post_booking_bags_checkout_button',
        priceBreakdown: '.post_booking_price_breakdown_toggle',
        purchaseButton: '.post_booking_purchase_purchase_button',
        translations: '.post_booking_bags_translations',
        phoneNumber: '.post_booking_bags_confirmation_contact_phone_number',
        baggageFeeDisclaimerContainer: '.post_booking_baggage_fee_disclaimer_container',
    },
    tmpls: {
        waitingTemplate: '#post_booking_bags_waiting_template',
        infoTemplate: '#post_booking_bags_info_template',
        flightSectionInfoTemplate: '#post_booking_flight_section_info_template',
        travelerTemplate: '#post_booking_bags_traveler_template',
        segmentTemplate: '#post_booking_bags_segment_template',
        airportTemplate: '#post_booking_bags_airport_template',
        includedBaggageTemplate: '#post_booking_bags_included_baggage_template',
        noSelectableBaggageTemplate: '#post_booking_bags_no_selectable_baggage_template',
        selectableBaggageTemplate: '#post_booking_bags_selectable_baggage_template',
        selectableBaggageOptionTemplate: '#post_booking_bags_selectable_baggage_option_template',
        baggageSelectedTemplate: '#post_booking_bags_baggage_selected_template',
        checkoutTemplate: '#post_booking_bags_checkout_template',
        priceBreakdownItemTemplate: '#post_booking_price_breakdown_item_template',
        priceBreakdownTemplate: '#post_booking_price_breakdown_template',
        purchaseTemplate: '#post_booking_bags_purchase_template',
        noCoverageTemplate: '#post_booking_generic_message_template',
    },
    events: {
        'tap @headerBack': 'onTapBack',
        'tap @back': 'onTapBack',
        'change @selectBag': 'onSelectBag',
        'mousedown @selectBag': 'onTabSelectBagButton',
        'tap @removeBag': 'onRemoveBag',
        'tap @checkoutButton': 'onCheckout',
        'tap @priceBreakdown': 'onPriceBreakdownToggle',
        'tap @purchaseButton': 'onPurchase',
        'tap @phoneNumber': 'onTapPhoneNumber',
    },

    init: function() {
        this.tmpls = Odigeo.Utils.getTemplates(this.$el, this.tmpls);
        this.translations = Odigeo.Utils.parseJson(this.$cachedSelectors.translations.html());
        if (Odigeo.AB.isOneClickCheckout) {
            this.createOneClickCheckout();
        }
    },

    createOneClickCheckout() {
        this.oneClickCheckoutContainer = oneClickCheckoutFactory.create({
            el: this.$el.find(this.$cachedSelectors.oneClickCheckout),
            id: 'one-click-checkout-post-booking-bags',
            productType: 'BAGGAGE',
            contentKeys: {
                feedbackConfirmationTitle: 'bagsConfirmationTitle',
                feedbackConfirmationSubtitle: 'bagsConfirmationSubtitle',
                feedbackConfirmationButton: 'bagsConfirmationButton',
                feedbackErrorTitle: 'bagsErrorTitle',
                feedbackErrorSubtitle: 'bagsErrorSubtitle',
                feedbackErrorButton: 'bagsErrorButton',
            },
        });
    },

    enhanceBaggageFeeHint() {
        if (this.$cachedSelectors.baggageFeeDisclaimerContainer.length) {
            Odigeo.UIElements.hint.enhance(
                Odigeo.History.getPageNameFromFragment(),
                this.$cachedSelectors.baggageFeeDisclaimerContainer, {
                    events: {
                        tap: true,
                    },
                });
        }
    },

    hide: function($e) {
        $e.addClass('odf-hidden');
    },

    show: function($e) {
        $e.removeClass('odf-hidden');
    },

    display: function($e, display) {
        $e.toggleClass('odf-hidden', !display);
    },

    scrollToTop: function() {
        Odigeo.Utils.scrollToElement($('body'), {
            container: this.selectors.body,
            animation: false,
        });
    },

    getFlightType: function(tripType, type, segmentIndex) {
        var result;
        var flightTypes = this.translations.flightTypes;

        switch (tripType) {
            case 'ONE_WAY':
                result = flightTypes.oneWay;
                break;
            case 'ROUND_TRIP':
                result = (segmentIndex === 0) ? flightTypes.roundTrip.outbound : flightTypes.roundTrip.inbound;
                break;
            case 'MULTIPLE_DESTINATIONS':
            case 'MULTI_SEGMENT':
                result = flightTypes.multiSegment[segmentIndex];
                break;
        }

        return result;
    },

    getBagsTranslation: function(pieces, kilos, isExtraBag) {
        const translations = this.translations;
        const conceptWithWeight = Odigeo.AB.isDisplayTotalBaggageWeightAllowance && pieces > 1 ?
            translations.bagsPiecesWithTotalKilos : translations.bagsPiecesWithKilos;
        const conceptWithWeightExtra = Odigeo.AB.isDisplayTotalBaggageWeightAllowance ?
            translations.bagsExtraPiecesWithTotalKilos : translations.bagsExtraPiecesWithKilos;
        const translation = kilos > 0 ?
            (isExtraBag ? conceptWithWeightExtra : conceptWithWeight)
            : (isExtraBag ? translations.bagsExtraPieces : translations.bagsPieces);

        return Odigeo.Utils.pluralizeAll(translation, pieces, kilos);
    },

    renderWaiting: function(waitingMessage) {
        return this.tmpls.waitingTemplate(waitingMessage);
    },

    renderInfo: function(contentInfo) {
        return this.tmpls.infoTemplate(contentInfo);
    },

    renderFlightInfo: function(segmentsInfo) {
        return Odigeo._.reduce(segmentsInfo, function(acc, segment, segmentIndex) {
            return acc + this.renderFlightSectionInfo(segment, segmentIndex);
        }, '', this);
    },

    renderFlightSectionInfo: function(segment, segmentIndex) {
        var sections = segment.sections;
        var firstSection = sections[0].section;
        var lastSection = sections[sections.length - 1].section;
        var fromIata = firstSection.from.cityIataCode;
        var toIata = lastSection.to.cityIataCode;
        var from = firstSection.from.cityName;
        var to = lastSection.to.cityName;
        var date = Odigeo.Utils.formatDate(firstSection.departureDate, 'ddd, d mmm');
        var dateLong = Odigeo.Utils.formatDate(firstSection.departureDate, 'ddd, d mmm yyyy');
        var direction = segmentIndex === 0 ? 'right' : 'left';

        return this.tmpls.flightSectionInfoTemplate({
            direction: direction,
            fromIata: fromIata,
            toIata: toIata,
            from: from,
            to: to,
            date: date,
            dateLong: dateLong,
        });
    },

    renderTravelers: function(travelers, segmentsInfo, itineraryInfo) {
        return Odigeo._.reduce(travelers, function(acc, traveler) {
            return acc + this.renderTraveler(traveler, segmentsInfo, itineraryInfo);
        }, '', this);
    },

    renderTraveler: function(traveler, segmentsInfo, itineraryInfo) {
        var travelerName = [traveler.name, traveler.middleName, traveler.firstLastName, traveler.secondLastName].join(' ');
        var travelerType = Odigeo._.capitalize(traveler.travellerType.toLowerCase());
        var segments = this.renderSegments(traveler, segmentsInfo, itineraryInfo);

        return this.tmpls.travelerTemplate({
            travelerName: travelerName,
            travelerType: travelerType,
            segments: segments,
        });
    },

    renderSegments: function(traveler, segmentsInfo, itineraryInfo) {
        return Odigeo._.reduce(segmentsInfo, function(acc, segment, segmentIndex) {
            return acc + this.renderSegment(segment, segmentIndex, traveler, itineraryInfo);
        }, '', this);
    },

    renderSegment: function(segment, segmentIndex, traveler, itineraryInfo) {
        var sections = segment.sections;
        var firstSection = sections[0].section;
        var lastSection = sections[sections.length - 1].section;
        var carrierCode = firstSection.carrier.code;
        var flightType = this.getFlightType(itineraryInfo.tripType, itineraryInfo.type, segmentIndex);
        var airports = this.renderAirport(flightType, firstSection, lastSection);
        var includedBaggage = this.renderIncludedBaggage(traveler, segmentIndex);
        var selectableBaggage = this.renderSelectableBaggage(traveler, segmentIndex);

        return this.tmpls.segmentTemplate({
            travelerIndex: traveler.travellerNumber,
            segmentIndex: segmentIndex,
            carrierCode: carrierCode,
            airports: airports,
            includedBaggage: includedBaggage,
            selectableBaggage: selectableBaggage,
        });
    },

    renderAirport: function(flightType, firstSection, lastSection) {
        var fromIata = firstSection.from.cityIataCode;
        var toIata = lastSection.to.cityIataCode;
        var from = firstSection.from.cityName;
        var to = lastSection.to.cityName;

        return this.tmpls.airportTemplate({
            flightType: flightType,
            fromIata: fromIata,
            toIata: toIata,
            from: from,
            to: to,
        });
    },

    bagsInfo: function(traveler, segmentIndex) {
        var pluralizeAll = Odigeo.Utils.pluralizeAll;
        var travelerType = traveler.travellerType.toUpperCase();
        var hasIncludedBags = this.model.hasIncludedBags(travelerType, segmentIndex);
        var includedBags = this.model.getIncludedBags(travelerType, segmentIndex);
        var hasPaidBags = this.model.hasPaidBagsForSegment(traveler, segmentIndex);
        var paidBags = this.model.getPaidBagsForSegment(traveler, segmentIndex);
        var hasSelectedBags = this.widget.hasSelectedBagForSegment(traveler, segmentIndex);
        var selectedBags = this.widget.getSelectedBagForSegment(traveler, segmentIndex);
        var result = {
            hasIncludedBags: false,
            hasPaidBags: false,
            hasSelectedBags: false,
            hasBags: false,
            includedPieces: 0,
            paidPieces: 0,
            selectedPieces: 0,
            pieces: 0,
            amount: 0,
            bagsText: this.translations.bagsNone,
            extraBagsText: this.translations.bagsNotAvailable,
        };

        if (travelerType === 'INFANT') {
            return result;
        }

        if (hasIncludedBags) {
            result.hasIncludedBags = true;
            result.includedPieces = includedBags.pieces;
            result.pieces += includedBags.pieces;
        }

        if (hasPaidBags) {
            result.hasPaidBags = true;
            result.paidPieces = paidBags.pieces;
            result.pieces += paidBags.pieces;
        }

        if (hasSelectedBags) {
            result.hasSelectedBags = true;
            result.selectedPieces = selectedBags.pieces;
        }

        if (hasIncludedBags || hasPaidBags) {
            result.hasBags = true;

            if (includedBags.kilos > 0 && paidBags.kilos > 0 && includedBags.kilos === paidBags.kilos) {
                result.bagsText = pluralizeAll(this.translations.bagsPiecesWithKilos, result.pieces, includedBags.kilos);
            } else if (includedBags.kilos > 0) {
                result.bagsText = pluralizeAll(this.translations.bagsPiecesWithKilos, result.pieces, includedBags.kilos);
            } else if (paidBags.kilos > 0) {
                result.bagsText = pluralizeAll(this.translations.bagsPiecesWithKilos, result.pieces, paidBags.kilos);
            } else {
                result.bagsText = pluralizeAll(this.translations.bagsPieces, result.pieces);
            }
        }

        result.amount = Odigeo.Utils.formatCurrency(result.amount);

        return result;
    },

    renderIncludedBaggage: function(traveler, segmentIndex) {
        var params = this.bagsInfo(traveler, segmentIndex);
        return this.tmpls.includedBaggageTemplate(params);
    },

    renderSelectableBaggage: function(traveler, segmentIndex) {
        var travelerType;
        var selectedBag;

        if (this.model.hasPaidBagsForSegment(traveler, segmentIndex)) {
            return this.renderNoSelectableBags();
        }

        travelerType = traveler.travellerType.toUpperCase();
        selectedBag = this.widget.getSelectedBagForSegment(traveler, segmentIndex);

        if (this.widget.hasSelectedBagForSegment(traveler, segmentIndex)) {
            return this.renderSelectedBagsForSegment(traveler, segmentIndex, selectedBag);
        } else if (this.model.hasSelectableBagsForSegment(travelerType, segmentIndex)) {
            return this.renderBaggageDropdown(travelerType, segmentIndex, traveler.travellerNumber, selectedBag);
        }

        return this.renderNoSelectableBags();
    },

    renderNoSelectableBags: function() {
        return this.tmpls.noSelectableBaggageTemplate();
    },

    renderBaggageDropdown: function(travelerType, segmentIndex, travelerIndex, selectedBag) {
        var isExtraBag = this.model.hasIncludedBags(travelerType, segmentIndex);
        var options = this.renderSelectableBaggageOptions(travelerType, segmentIndex, travelerIndex, isExtraBag, selectedBag);
        var noBagsText = isExtraBag ? this.translations.dropdownNoExtraBags : this.translations.dropdownNoBags;

        return this.tmpls.selectableBaggageTemplate({
            travelerIndex: travelerIndex,
            segmentIndex: segmentIndex,
            options: options,
            noBagsText: noBagsText,
        });
    },

    renderSelectableBaggageOptions: function(travelerType, segmentIndex, travelerIndex, isExtraBag, selectedBag) {
        var selectableBags = this.model.getSelectableBagsForSegment(travelerType, segmentIndex);

        return Odigeo._.reduce(selectableBags, function(acc, selectableBag, bagIndex) {
            return acc + this.renderSelectableBaggageOption(selectableBag, travelerIndex, segmentIndex, bagIndex, isExtraBag, selectedBag);
        }, '', this);
    },

    renderSelectableBaggageOption: function(selectableBag, travelerIndex, segmentIndex, bagIndex, isExtraBag, selectedBag) {
        var label = this.getBagsTranslation(selectableBag.pieces, selectableBag.kilos, isExtraBag);
        var amount = Odigeo.Utils.formatCurrency(selectableBag.amount, selectableBag.currencyConfig);
        var isSelected = !Odigeo._.isUndefined(selectedBag) && selectedBag.bagIndex === bagIndex ? 'selected' : '';

        return this.tmpls.selectableBaggageOptionTemplate({
            travelerIndex: travelerIndex,
            segmentIndex: segmentIndex,
            bagIndex: bagIndex,
            label: label,
            amount: amount,
            isSelected: isSelected,
        });
    },

    renderCheckout: function() {
        trackingUtils.trackEventWithCategory(CATEGORY, 'baggage_offline_add', 'baggage_offline_add_appearances');
        var totalPrice = Odigeo.Utils.formatCurrency(this.widget.getTotalPrice(), this.widget.getCurrencyConfig());
        var totalPieces = this.getBagsTranslation(this.widget.getTotalPieces(), -1, false);
        var showTotalPieces = this.widget.getTotalPieces() > 0;
        var enableCheckout = this.widget.hasSelectedAnyBags();
        const baggageFee = this.widget.getAverageFee();
        const showBaggageFee = this.widget.hasSelectedAnyBags() && baggageFee !== 0;

        return this.tmpls.checkoutTemplate({
            totalPrice: totalPrice,
            totalPieces: totalPieces,
            showTotalPieces: showTotalPieces,
            enableCheckout: enableCheckout,
            showBaggageFee: showBaggageFee,
            baggageFee: baggageFee,
            baggageFeeDisclaimerText: this.translations.baggageFeeDisclaimer,
        });
    },

    renderPriceBreakdownItems: function() {
        var priceBreakdown = this.widget.getPriceBreakdown();
        var currencyConfig = this.widget.getCurrencyConfig();

        return Odigeo._.chain(priceBreakdown)
            .map(function(el) {
                return Odigeo._.extend(el, {
                    item: this.getBagsTranslation(el.pieces, el.kilos, true),
                    price: Odigeo.Utils.formatCurrency(el.price, currencyConfig),
                    fee: Odigeo.Utils.formatCurrency(el.fee, currencyConfig),
                    amount: Odigeo.Utils.formatCurrency(el.amount, currencyConfig),
                    totalPrice: Odigeo.Utils.formatCurrency(el.totalPrice, currencyConfig),
                    totalFee: Odigeo.Utils.formatCurrency(el.totalFee, currencyConfig),
                    totalAmount: Odigeo.Utils.formatCurrency(el.totalAmount, currencyConfig),
                });
            }, this)
            .map(this.tmpls.priceBreakdownItemTemplate)
            .value()
            .join('');
    },

    renderPriceBreakdown: function() {
        var totalPrice = Odigeo.Utils.formatCurrency(this.widget.getTotalPrice(), this.widget.getCurrencyConfig());
        var totalPieces = this.getBagsTranslation(this.widget.getTotalPieces(), -1, false);
        var priceBreakdownItems = this.renderPriceBreakdownItems();

        return this.tmpls.priceBreakdownTemplate({
            priceBreakdownItems: priceBreakdownItems,
            totalPieces: totalPieces,
            totalPrice: totalPrice,
        });
    },

    renderPurchase: function() {
        var totalPrice = Odigeo.Utils.formatCurrency(this.widget.getTotalPrice(), this.widget.getCurrencyConfig());
        var enablePurchase = this.widget.allowPurchase();
        var priceBreakdown = '';
        var cardType = '';

        if (this.model.get('creditCardTypeName')) {
            cardType = Odigeo.Utils.replaceCmsKeyArgs(this.translations.cardType, this.model.get('creditCardTypeName'));
        }

        if (this.isPriceBreakdownOpen) {
            priceBreakdown = this.renderPriceBreakdown();
        }

        return this.tmpls.purchaseTemplate({
            totalPrice: totalPrice,
            enablePurchase: enablePurchase,
            priceBreakdown: priceBreakdown,
            isPriceBreakdownOpen: this.isPriceBreakdownOpen,
            cardType: cardType,
        });
    },

    renderNoCoveragePopup() {
        if (!this.$cachedSelectors.failure.html()) {
            const content = this.tmpls.noCoverageTemplate({
                imageClass: 'od-post-booking-bags-no-coverage-icon',
                title: this.translations.noCoverageTitle,
                subtitle: this.translations.noCoverageDescription,
                buttonLabel: this.translations.noCoverageButtonClose,
            });

            this.$cachedSelectors.failure.html(content);
        }
    },

    widgetInfo: function() {
        const phase = this.model.get('phase');
        const isLoading = phase === this.model.phases.LOADING;
        const isShopping = phase === this.model.phases.SHOPPING;
        const isCheckout = phase === this.model.phases.CHECKOUT;
        const isPayment = phase === this.model.phases.PAYMENT;
        const isBuying = phase === this.model.phases.BUYING;
        const isSuccess = phase === this.model.phases.SUCCESS;
        const isFailure = phase === this.model.phases.FAILURE;
        const isOneClickCheckoutInteraction = phase === this.model.phases.ONE_CLICK_CHECKOUT_INTERACTION;
        const isPaymentFailure = phase === this.model.phases.PAYMENT_FAILURE;
        const showFlightInfo = this.model.showFlightInfo();
        const showPayment = isPayment;
        const showHeaderTitle = !isSuccess && !isPaymentFailure && !isFailure;
        const showFooterBackLink = isFailure || isPaymentFailure;
        let travelers;
        let segmentsInfo;
        let itineraryInfo;
        let waitingMessage ='';
        let flightInfoContent ='';
        let travelersContent = '';
        let checkoutContent = '';
        let purchaseContent = '';

        if (this.model.hasInfo()) {
            travelers = this.model.getTravelers();
            segmentsInfo = this.model.getSegmentsInfo();
            itineraryInfo = this.model.getItineraryInfo();

            if (showFlightInfo && !isSuccess && !isFailure && !isPaymentFailure) {
                flightInfoContent = this.renderFlightInfo(segmentsInfo);
            }

            if (!isSuccess && !isFailure && !isPaymentFailure) {
                travelersContent = this.renderTravelers(travelers, segmentsInfo, itineraryInfo);
            }
        }

        if (isShopping || isCheckout) {
            checkoutContent = this.renderCheckout();
        }

        if (isPayment) {
            purchaseContent = this.renderPurchase();
        }

        if (isLoading) {
            waitingMessage = this.translations.loadingWaitingMessage;
        }

        if (isBuying) {
            waitingMessage = this.translations.buyingWaitingMessage;
        }

        const acillaryOptionsContainer = this.model.getAncillaryOptionsContainer();
        const debugInfo = Odigeo._.get(acillaryOptionsContainer, 'bagDebugInfo');
        return {
            isLoading,
            isBuying,
            waitingMessage,
            isSuccess,
            isFailure,
            isOneClickCheckoutInteraction,
            isPaymentFailure,
            showHeaderTitle,
            showFlightInfo,
            showPayment,
            flightInfo: flightInfoContent,
            travelers: travelersContent,
            checkout: checkoutContent,
            purchase: purchaseContent,
            showFooterBackLink,
            hasCheckout: isShopping || isCheckout,
            debugInfo,
        };
    },

    //
    // View actions
    //

    render: function() {
        if (this.isOpen) {
            const widgetInfo = this.widgetInfo();
            const shouldDisplayContent = (!widgetInfo.isLoading && !widgetInfo.isBuying) || widgetInfo.isOneClickCheckoutInteraction;
            this.$cachedSelectors.waiting.html(this.renderWaiting(widgetInfo));

            if (widgetInfo.isFailure) {
                this.renderNoCoveragePopup();
            }

            this.display(this.$cachedSelectors.waiting, widgetInfo.isLoading || widgetInfo.isBuying);
            this.$cachedSelectors.info.html(this.renderInfo(widgetInfo));

            this.display(this.$cachedSelectors.failure, widgetInfo.isFailure);

            if (Odigeo.AB.isOneClickCheckout) {
                this.$cachedSelectors.purchase.html(widgetInfo.purchase);
                this.display(this.$cachedSelectors.content, shouldDisplayContent);
                this.display(this.$cachedSelectors.info, !widgetInfo.isBuying && !widgetInfo.isOneClickCheckoutInteraction);
                this.display(this.$cachedSelectors.purchase, !widgetInfo.isBuying);
            } else {
                this.display(this.$cachedSelectors.payment, widgetInfo.showPayment);
                this.$cachedSelectors.purchase.html(widgetInfo.purchase);
                this.display(this.$cachedSelectors.content, shouldDisplayContent);
                this.display(this.$cachedSelectors.success, widgetInfo.isSuccess);
                this.display(this.$cachedSelectors.paymentFailure, widgetInfo.isPaymentFailure);
            }

            this.afterRenderContent(widgetInfo);
            this.updateDomSelectorsToCache();
            if (widgetInfo.hasCheckout) {
                this.enhanceBaggageFeeHint();
            }
        }
    },

    removeContent: function() {
        this.beforeRemoveContent();
    },

    open: function() {
        this.widget.clearBagSelections();
        this.render();
        this.toggleMainPageScroll(true);
        this.scrollToTop();
    },

    close: function() {
        this.removeContent();
        this.toggleMainPageScroll(false);
        this.scrollToTop();
        if (Odigeo.AB.isOneClickCheckout) {
            this.oneClickCheckoutContainer.execute('cleanInputs');
        }
    },

    moveToPayment() {
        this.model.set('phase', this.model.phases.PAYMENT);
    },

    toggleMainPageScroll: function(isDisabling) {
        Odigeo.Device.getViewport().toggleClass('od-viewport-no-vertical-scroll', isDisabling);
    },

    //
    // Event handlers
    //

    onTapBack: function() {
        var action;
        var trackLabel = 'no-possible';
        if (this.model.get('phase') !== this.model.phases.FAILURE) {
            trackLabel = 'add';
        }
        if (this.model.get('baggageAdded')) {
            action = 'add';
            trackLabel = 'added';
        }
        trackingUtils.trackEventWithCategory(
            CATEGORY, 'baggage_offline_' + (action ? action : trackLabel),
            'baggage_offline_' + trackLabel + '_close');

        this.model.set('baggageAdded', false);
        Odigeo.trigger(this.widget.id + ':closeAddBags');
    },

    onTapPhoneNumber: function() {
        trackingUtils.trackEventWithCategory(CATEGORY, 'baggage_offline_no-possible', 'baggage_offline_no-possible_call');
    },

    onTabSelectBagButton: function(e) {
        var $el = $(e.currentTarget).find('option:selected');
        var data = $el.data();
        var travelerIndex = data.travelerIndex || $(e.currentTarget).data('travelerIndex');
        var bagIndex = data.bagIndex;
        var action = Odigeo._.isNumber(bagIndex) ? 'edit' : 'add';

        trackingUtils.trackEventWithCategory(CATEGORY,
            'baggage_offline_add',
            'click_' + action + '_baggage_offline_' + travelerIndex
        );
    },

    onSelectBag: function(e) {
        var $el = $(e.currentTarget).find('option:selected');
        var data = $el.data();
        var travelerIndex = data.travelerIndex;
        var segmentIndex = data.segmentIndex;
        var bagIndex = data.bagIndex;
        var bookingId = this.model.getBookingId();
        var traveler = this.model.getTraveler(travelerIndex);
        var selectableBaggage = this.model.getSelectableBag(traveler.travellerType, segmentIndex, bagIndex);
        var bagsCount = selectableBaggage.pieces || 0;
        var segmentType = segmentIndex === 0 ? 'Departure' : 'Return';
        var selectionTypeId = Odigeo._.isNumber(bagIndex) ? '1' : '0';

        if (Odigeo._.isNumber(bagIndex)) {
            if (this.model.baggageSelection === null) {
                this.model.baggageSelection = [{
                    segmentIndex: segmentIndex,
                    travelerIndex: traveler.travellerNumber,
                }];
            } else {
                this.model.baggageSelection.push({
                    segmentIndex: segmentIndex,
                    travelerIndex: traveler.travellerNumber,
                });
            }
            this.widget.selectBag(travelerIndex, segmentIndex, bagIndex);
        } else {
            if (!Odigeo._.isUndefined(travelerIndex) && !Odigeo._.isUndefined(segmentIndex)) {
                Odigeo._.remove(this.model.baggageSelection, {
                    segmentIndex: segmentIndex,
                    travelerIndex: travelerIndex,
                });
                this.widget.removeBag(travelerIndex, segmentIndex);
            } else {
                this.model.baggageSelection = null;
                this.render();
            }
        }

        trackingUtils.trackEventWithCategory(
            CATEGORY,
            'baggage_offline_add',
            'added_baggage_offline_' + segmentType + '_' + selectionTypeId + '_' + bagsCount + '_' + bookingId
        );
    },

    onRemoveBag: function(e) {
        var $el = $(e.currentTarget);
        var data = $el.data();
        var travelerIndex = data.travelerIndex;
        var segmentIndex = data.segmentIndex;

        this.widget.removeBag(travelerIndex, segmentIndex);
        trackingUtils.trackEventWithCategory(
            CATEGORY,
            'baggage_offline_add',
            'click_remove_baggage_offline_' + travelerIndex
        );
    },

    onCheckout: function() {
        if (this.widget.hasSelectedAnyBags()) {
            if (Odigeo.AB.isOneClickCheckout) {
                this.oneClickCheckoutContainer.execute('togglePaymentForm', {
                    show: true,
                    isLoading: true,
                });
                this.widget.selectAncillariesAndAddToShoppingBasket();
            }

            this.trackingCheckout('success', '');
            this.model.set('phase', this.model.phases.PAYMENT);
        }
    },

    onPriceBreakdownToggle: function() {
        this.isPriceBreakdownOpen = !this.isPriceBreakdownOpen;
        this.render();
    },

    onPurchase: function() {
        if (this.widget.allowPurchase()) {
            this.model.set('phase', this.model.phases.BUYING);

            this.widget.trackNumBaggages('pay');
            this.widget.trackPage('payment');

            if (Odigeo.AB.isOneClickCheckout) {
                this.oneClickCheckoutContainer.execute('checkout');
            } else {
                this.widget.purchaseBags();
            }
        }
    },

    onCheckoutConfirm() {
        this.model.set('phase', this.model.phases.SUCCESS);
    },

    onCheckoutInteractionNeeded() {
        this.model.set('phase', this.model.phases.ONE_CLICK_CHECKOUT_INTERACTION);
    },

    onCheckoutPaymentRetry() {
        this.model.set('phase', this.model.phases.PAYMENT_FAILURE);
    },

    trackingCheckout: function(eventToTrack, reason) {
        trackingUtils.trackEventWithCategory(
            CATEGORY,
            'baggage_offline_add',
            'baggage_offline_added_' + eventToTrack + reason
        );

        this.widget.trackNumBaggages('continue');

        trackingUtils.trackEventWithCategory(
            CATEGORY,
            'baggage_offline_add',
            'baggage_offline_click_continue_' + eventToTrack + reason
        );

        this.model.set('baggageAdded', true);
    },
};
